import { render, staticRenderFns } from "./GovPage.vue?vue&type=template&id=7f1dc5a0"
import script from "./GovPage.vue?vue&type=script&lang=js"
export * from "./GovPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports